import React from "react";

export default function OkButton({
  prefixCls,
  locale,
  okDisabled,
  onOk,
  ecId
}) {
  let className = `${prefixCls}-ok-btn`;
  if (okDisabled) {
    className += ` ${prefixCls}-ok-btn-disabled`;
  }
  return (
    <a
      ecId={`${ecId}_a@iqxxsu`}
      className={className}
      role="button"
      onClick={okDisabled ? null : onOk}
    >
      {locale.ok}
    </a>
  );
}



// WEBPACK FOOTER //
// ./_rc-calendar-5.6.2/src/calendar/OkButton.jsx